/**
 * Capitalizes the first character in the supplied text
 */
export function capitalize(text = ''): string {
	return text.length ? text[0].toUpperCase() + text.substr(1) : '';
}
